import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./styles/github-markdown-css/github-markdown.css";
import "./i18n"; // 引入 i18n 配置
import CustomThemeProvider from "./providers/CustomThemeProvider";

if (process.env.REACT_APP_ENV?.startsWith("production")) {
	console.log = () => {};
	console.error = () => {};
	console.debug = () => {};
}
console.log("process.env.REACT_APP_ENV", process.env.REACT_APP_ENV);

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);
root.render(
	<CustomThemeProvider>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</CustomThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
